import React from 'react';
import PropTypes from 'prop-types';

import { useAssetImages } from '../../../hooks';
import HeroImageGallery from './HeroImageGallery';


export default function HeroImageGalleryWithFetch({
    assetId,
    campsiteId,
    tourId,
    hasThumbnailStrip,
    className
}) {
    const { heroImage, galleryImages, status } = useAssetImages({ assetId, campsiteId, tourId });

    return (
        <HeroImageGallery
            heroImage={heroImage}
            galleryImages={galleryImages}
            status={status}
            hasThumbnailStrip={hasThumbnailStrip}
            className={className} />
    );
}

HeroImageGalleryWithFetch.propTypes = {
    /** The id of the campground/permit/ticket facility/gateway/POI that the
     * api will use to fetch the images.
     * Do not use the images prop if using this prop. */
    assetId: PropTypes.string,

    /** The id of the campsite that the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    campsiteId: PropTypes.string,

    /** The tour id the api will use to fetch the images
     * Do not use the images if using this prop.
    */
    tourId: PropTypes.string,

    /** Shows the thumbnail strip at the bottom of the open gallery */
    hasThumbnailStrip: PropTypes.bool,

    /** Additional className added to the outer container */
    className: PropTypes.string
};
HeroImageGalleryWithFetch.defaultProps = {
    hasThumbnailStrip: true
};
